var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1888_3650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4998 0.856445H10.4949C5.17811 0.856445 0.854492 5.18127 0.854492 10.4993C0.854492 12.6087 1.53431 14.5638 2.69025 16.1512L1.48851 19.7335L5.19498 18.5487C6.71976 19.5588 8.53864 20.1422 10.4998 20.1422C15.8166 20.1422 20.1402 15.8161 20.1402 10.4993C20.1402 5.18247 15.8166 0.856445 10.4998 0.856445ZM16.1107 14.4734C15.8781 15.1303 14.9548 15.6751 14.2183 15.8342C13.7144 15.9415 13.0563 16.0271 10.8409 15.1086C8.00708 13.9346 6.18217 11.055 6.03994 10.8681C5.90373 10.6813 4.89485 9.34337 4.89485 7.95962C4.89485 6.57587 5.59757 5.90207 5.88083 5.61278C6.11347 5.37533 6.49797 5.26685 6.86681 5.26685C6.98614 5.26685 7.09342 5.27287 7.18985 5.2777C7.47311 5.28975 7.61534 5.30662 7.80217 5.75381C8.0348 6.3143 8.60132 7.69805 8.66882 7.84029C8.73753 7.98252 8.80623 8.17537 8.70981 8.36221C8.6194 8.55506 8.53985 8.64064 8.39762 8.80457C8.25539 8.9685 8.12039 9.09386 7.97815 9.26984C7.84797 9.42292 7.70092 9.58685 7.86485 9.87011C8.02878 10.1473 8.5953 11.0718 9.4294 11.8143C10.5058 12.7726 11.3785 13.0788 11.6907 13.2089C11.9233 13.3054 12.2005 13.2825 12.3705 13.1017C12.5862 12.869 12.8526 12.4833 13.1238 12.1036C13.3167 11.8312 13.5602 11.7975 13.8157 11.8939C14.0761 11.9843 15.4538 12.6653 15.737 12.8064C16.0203 12.9486 16.2071 13.0161 16.2758 13.1354C16.3433 13.2547 16.3433 13.8152 16.1107 14.4734Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1888_3650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2857,
    height: 19.2857,
    fill: "white",
    transform: "translate(0.857422 0.857422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/whatsApp.f9c91a372d468137915993c481b49ee5.svg";
export { ForwardRef as ReactComponent };